var React = require('react');

function LogoFb (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.7389 5.32001H16.1542C15.0118 5.32001 13.9161 5.76251 13.1082 6.55016C12.3004 7.33781 11.8465 8.4061 11.8465 9.52001V12.04H9.26193V15.4H11.8465V22.12H15.2927V15.4H17.8773L18.7389 12.04H15.2927V9.52001C15.2927 9.29723 15.3835 9.08357 15.545 8.92604C15.7066 8.76851 15.9257 8.68001 16.1542 8.68001H18.7389V5.32001Z","fill":"white","key":0}),React.createElement("circle",{"cx":"14.0001","cy":"14","r":"13.5","stroke":"white","key":1})]);
}

LogoFb.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = LogoFb;

LogoFb.default = LogoFb;
